import React, { useMemo } from "react";
import { Alert, Form, Spinner } from "react-bootstrap";
import Modal from "../../../../Utilities/DraggableModal";
import useFetch from "../../../../Utilities/useFetch";

const AudioTranscriptsOnlyModal = ({ show, onHide, debtorID }) => {
  const { REACT_APP_API_URL } = process.env;
  const {
    data: transcripts,
    loading,
    error,
  } = useFetch(
    show && Boolean(debtorID),
    `${REACT_APP_API_URL}/Claims/GetAudioTranscriptsOnly`,
    "GET",
    null,
    { debtorid: debtorID }
  );

  const transcriptItems = useMemo(() => {
    if (Array.isArray(transcripts)) {
      return transcripts;
    }

    if (!transcripts || typeof transcripts !== "object") {
      return [];
    }

    if (Array.isArray(transcripts.transcripts)) {
      return transcripts.transcripts;
    }

    return [transcripts];
  }, [transcripts]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Audio Transcripts</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!debtorID ? (
          <Alert variant="warning">Debtor ID is required.</Alert>
        ) : loading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading audio transcripts...</p>
          </div>
        ) : error ? (
          <Alert variant="danger">Failed to load audio transcripts.</Alert>
        ) : transcriptItems.length > 0 ? (
          transcriptItems.map((item, index) => (
            <div key={item.audioTranscriptID || index} className="mb-4 border rounded p-3">
              <h6 className="mb-2">Transcript {index + 1}</h6>
              <ul className="mb-3">
                <li>Audio Transcript ID: {item.audioTranscriptID || ""}</li>
                <li>Debtor ID: {item.debtorID ?? ""}</li>
                <li>Collector: {item.collector || ""}</li>
                <li>From: {item.fromPhoneNumber || ""}</li>
                <li>To: {item.toPhoneNumber || ""}</li>
                <li>Created (UTC): {item.creationDateUTC || ""}</li>
              </ul>
              <Form.Control
                as="textarea"
                rows={10}
                value={item.transcription || ""}
                readOnly
                placeholder="No transcript content provided."
                style={{ whiteSpace: "pre-wrap" }}
              />
            </div>
          ))
        ) : (
          <p>No audio transcripts available.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AudioTranscriptsOnlyModal;